import { useState } from "react";
import { useDropzone } from "react-dropzone";
import { MediaCollection, ModelType } from "@/gql/graphql";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createMediaMutation } from "@/app/Media/GraphQL/mediaMutations";
import { useFileUpload } from "@/lib/FileUpload/Hooks/useFileUpload";
import { IMAGE_ACCEPT } from "@/lib/FileUpload/accept";

export function useSupplierImageDropzone({
  supplierId,
  collection,
}: {
  supplierId: string;
  collection: MediaCollection;
}) {
  const { mutateAsync: uploadFiles } = useFileUpload();
  const { mutateAsync: createMedia } = useGqlMutation(createMediaMutation);
  const [isUploading, setIsUploading] = useState(false);

  const dropzone = useDropzone({
    accept: IMAGE_ACCEPT,
    multiple: false,
    disabled: isUploading,
    onDropAccepted: async (files) => {
      setIsUploading(true);
      try {
        const [upload] = await uploadFiles(files);
        await createMedia({
          input: {
            file_name: upload.file.name,
            key: upload.filePath,
            collectionName: collection,
            objectType: ModelType.Supplier,
            objectId: supplierId,
          },
        });
      } finally {
        setIsUploading(false);
      }
    },
  });

  return { ...dropzone, isUploading };
}

export type SupplierImageDropzoneState = ReturnType<
  typeof useSupplierImageDropzone
>;
